import { helpers } from '@vuelidate/validators';

export const validNameRegex = /^[A-Za-z0-9\'\- ]+$/;

export const invalidCharactersRegex = /[^A-Za-z0-9\'\- ]/;

export const validName = helpers.regex(validNameRegex);
